import {
    ACCESS_TOKEN_MAX_AGE_SECOND,
    REFRESH_TOKEN_MAX_AGE_SECOND,
} from '@constants/auth';
import useUser from '@hooks/auth/useUser';
import useToast from '@hooks/ui/useToast';
import { SignInResponse } from '@models/auth';
import { useFlow } from '@stackflow/react';
import axios, { AxiosResponse } from 'axios';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

function reissueToken(refreshToken: string): Promise<AxiosResponse<SignInResponse>> {
    return axios.post(
        `${import.meta.env.VITE_API_URL}/auth/token/refresh`,
        { refreshToken },
    );
}

function useOnIdentifySuccess(refreshToken: string) {
    const toast = useToast();
    const [_, setCookies] = useCookies(['accessToken', 'refreshToken']);
    const { replace } = useFlow();
    const { getUserProfile } = useUser();
    const { t } = useTranslation('common');

    const setToken = async () => {
        try {
            const res = (await reissueToken(refreshToken)).data;
            setCookies('accessToken', res.token, {
                path: '/',
                maxAge: ACCESS_TOKEN_MAX_AGE_SECOND,
            });
            setCookies('refreshToken', res.refreshToken, {
                path: '/',
                maxAge: REFRESH_TOKEN_MAX_AGE_SECOND,
            });
            getUserProfile();
            replace('MainActivity', {}, { animate: false });
        } catch (e) {
            replace('MainActivity', {}, { animate: false });
            toast.error(t('identifyFailed'));
            console.error('본인증 후 오류 ', e);
        }
    };
    useEffect(() => {
        setToken();
    }, [refreshToken]);
}

export default useOnIdentifySuccess;
